/**
 * Editions shelf + archive section. Nine locked headlines, one lock
 * message. The lock message is the same message it has been since the
 * shelf launched, because it is the correct message.
 */

import { EDITIONS_SHELF } from "./data";
import { presentSignup, presentWall, readerState } from "./gate-bridge";

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function renderEditions(host: HTMLElement): void {
  host.innerHTML = `
  <section class="wire-editions" id="editions">
    <div class="wire-editions__head">
      <h2 class="wire-editions__title">More editions</h2>
      <p class="wire-editions__sub">The shelf is full. The shelf is also locked. These facts are related.</p>
    </div>
    <div class="wire-editions__grid">
      ${EDITIONS_SHELF.map(
        (item) => `
      <article class="wire-edition">
        <p class="wire-edition__meta">${esc(item.universe)} · ${esc(item.date)}</p>
        <h3 class="wire-edition__headline">${esc(item.headline)}</h3>
        <button class="wire-edition__lock" type="button" data-lock="1">Sign up to read</button>
      </article>`,
      ).join("\n")}
    </div>
    <p class="wire-editions__fine">Editions older than 41.0 live in the archive, which also locks, for symmetry.</p>
  </section>`;

  for (const btn of Array.from(host.querySelectorAll<HTMLButtonElement>("[data-lock]"))) {
    btn.addEventListener("click", () => {
      if (readerState() === "anonymous") presentSignup();
      else presentWall();
    });
  }
}
